
export const loadingStates = {
    NONE: 0,
    LOADING: 1,
    SUCCESS: 2,
    FAILED: 3
}